"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedSwapProtocols = exports.DEFAULT_SWAP_PROTOCOLS = exports.TESTNET_PROTOCOLS = void 0;
exports.TESTNET_PROTOCOLS = {
    'RINKEBY': [{ network: 'RINKEBY', id: 'RINKEBY:UNISWAP_V2', title: 'Uniswap V2', img: '' }],
    'MUMBAI_TESTNET': [{ network: 'MUMBAI_TESTNET', id: 'MUMBAI_TESTNET:POLYGON_QUICKSWAP', title: 'Quick Swap', img: '' }],
    'BSC_TESTNET': [{ network: 'BSC_TESTNET', id: 'BSC_TESTNET:PANCAKESWAP_V2', title: 'Pancake Swap', img: '' }],
};
exports.DEFAULT_SWAP_PROTOCOLS = {
    'RINKEBY': ['RINKEBY:UNISWAP_V2'],
    'BSC_TESTNET': ['BSC_TESTNET:PANCAKE'],
    'MUMBAI_TESTNET': ['MUMBAI_TESTNET:QUICK_SWAP'],
    'ETHEREUM': ['ETHEREUM:UNISWAP_V2'],
    'BSC': ['BSC:PANCAKESWAP_V2'],
    'POLYGON': ['POLYGON:POLYGON_QUICKSWAP'],
};
exports.SupportedSwapProtocols = {
    'ETHEREUM': ['UNISWAP_V2'],
    'RINKEBY': ['UNISWAP_V2'],
    'POLYGON': [],
    'MUMBAI_TESTNET': ['QUICKSWAP'],
    'BSC': [],
    'BSC_TESTNET': ['PANCAKESWAP'],
};
//# sourceMappingURL=CrossSwapTypes.js.map